import { gql } from 'react-apollo';

export const deleteUserData = gql`
  mutation deleteUserData($input: DeleteUserDataInput!) {
    deleteUserData(input: $input) {
      user {
        id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/pages/settings/mutations/deleteUserData.js